window.app = window.app || {};

window.app.customer_experience = {
  el: {
    productsSlider: document.querySelector(
      ".mt-experience__products-slider .swiper"
    ),
    reviewsSlider: document.querySelector(
      ".mt-experience__reviews-slider .swiper"
    ),
  },
  productsSlider: null,
  reviewsSlider: null,

  init: function () {
    this.productsSlider = new Swiper(this.el.productsSlider, {
      slidesPerView: "auto",
      centeredSlides: true,
      loop: true,
      spaceBetween: 30,
      pagination: {
        el: ".mt-experience__dots .swiper-pagination",
        clickable: true,
      },
      navigation: {
        prevEl: ".mt-experience__toolbar .arrow-left",
        nextEl: ".mt-experience__toolbar .arrow-right",
      },
      speed: 500,
      preventInteractionOnTransition: true,
    });
    this.reviewsSlider = new Swiper(this.el.reviewsSlider, {
      slidesPerView: 1,
      loop: true,
      effect: "fade",
      pagination: {
        el: ".mt-experience__toolbar .swiper-pagination",
        type: "fraction",
      },
      speed: 500,
      preventInteractionOnTransition: true,
    });

    // this.productsSlider.on("slideNextTransitionStart", () => {
    //   this.reviewsSlider.slideNext(500, false);
    // });

    // this.productsSlider.on("slidePrevTransitionStart", () => {
    //   this.reviewsSlider.slidePrev(500, false);
    // });

    this.reviewsSlider.on("slideNextTransitionStart", () => {
      this.productsSlider.slideNext(500, false);
    });

    this.reviewsSlider.on("slidePrevTransitionStart", () => {
      this.productsSlider.slidePrev(500, false);
    });

    this.productsSlider.on("slideChange", () => {
      this.reviewsSlider.slideTo(this.productsSlider.realIndex + 1, 500, false);
    });
    // this.reviewsSlider.on("slideChange", () => {
    //   this.productsSlider.slideTo(this.reviewsSlider.realIndex + 1, 500, false);
    // });
  },
};

window.addEventListener("DOMContentLoaded", () => {
  window.app.customer_experience.init();
});
